import { render, staticRenderFns } from "./AddSubstractArticle.vue?vue&type=template&id=0d5c0b2b&scoped=true"
import script from "./AddSubstractArticle.vue?vue&type=script&lang=js"
export * from "./AddSubstractArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5c0b2b",
  null
  
)

export default component.exports